import React from 'react';
import produce from 'immer';
import axios from 'axios';
import { Button, Menu, MenuItem, styled, Backdrop, CircularProgress } from '@material-ui/core';
import BackgroundIcon from '../../../icons/BackgroundIcon';
import useDevices from '../../../hooks/useDevices/useDevices';
import { useAppSelector, useAppDispatch } from '../../../redux/hooks';
import FirebaseApp from '../../../state/useFirebaseAuth/FirebaseApp';
import { setColl } from '../../../redux/firebaseSlice';

export const IconContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  width: '1.5em',
  marginRight: '0.3em',
});

export default function VideoPictureButton(props: { disabled?: boolean; className?: string }) {
  const dispatch = useAppDispatch();
  const { hasVideoInputDevices } = useDevices();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openBack, setOpen] = React.useState(false);
  const urlParams: any = useAppSelector(state => state.collection.params);
  const collection: any = useAppSelector(state => state.collection.list);
  const items = collection.tokenData.data.items || [];
  const mattress = collection.tokenData.data.mattress || [];
  const handleCloseBack = () => {
    setOpen(false);
  };
  const open = Boolean(anchorEl);
  const handleClick = (event: any) => {
    if(items.length || mattress.length) setAnchorEl(event.currentTarget);
  };

  function menuItems() {
    let listmenu = items.map((item: any, i: number) => {
      return <MenuItem key={item.id} value={item.id} onClick={(e)=>handleClose(e)}>{`Item${i + 1} - ${item.title}`}</MenuItem>;
    });
    mattress.map((item: any, i: number) => {
      listmenu.push(<MenuItem key={item.id} value={item.id} onClick={(e)=>handleClose(e)}>{`Mattress${i + 1} - ${item.title}`}</MenuItem>);
    });
    return listmenu;
  }

  const handleClose = (event: any) => {
    const type = event.target.textContent.includes('Item') ? 'item' : 'mattress'
    setAnchorEl(null);
    if (event.target.value) VideoPicture(event.target.value, type);
  };

  const sendImages = (host: string, data: any) => {
    const params = new URLSearchParams();
    params.append('image_name', data.image_name);
    params.append('company_id', data.company_id);
    params.append('item_id', data.item_id);
    params.append('order_id', data.order_id);
    params.append('type', data.type);
    axios.post(`https://${host}/apis/virtual/upload_image_item`, params,
    {
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      }
    });
  }

  const VideoPicture = (id: number, type:string) => {
    setOpen(true);
    let video = document.querySelector('video');
    const o_id = collection.tokenData.data.o_id;
    let canvas = document.createElement('canvas');
    canvas.setAttribute('width', '800');
    canvas.setAttribute('height', '600');
    if (video) {
      canvas.getContext('2d')?.drawImage(video, 0, 0, canvas.width, canvas.height);
      let blobFile = canvas.toBlob(function(blob) {
        if (blob) {
          let file = new File([blob], `${id}_${o_id}_${Math.floor(Math.random() * 1000000000)}_videocallcrm.jpg`, {
            type: 'image/jpeg',
          });
          const formData = new FormData();
          formData.append('file', file);
          const url = '/api'
          axios.post(`${url}/add-image`, formData, {
            headers: {'api-key': process.env.REACT_APP_API_KEY || ''},
          })
            .then(res => {
              const tokenData: any = produce(collection, (draftState: any) => {
                let index
                if (type == 'item') {
                  index = draftState.tokenData.data.items.findIndex((x: any) => Number(x.id) === id);
                  if (draftState.tokenData.data.items[index].images) {
                    draftState.tokenData.data.items[index].images.push(file.name);
                  } else {
                    draftState.tokenData.data.items[index].images = [file.name];
                  }
                }else{
                  index = draftState.tokenData.data.mattress.findIndex((x: any) => Number(x.id) === id);
                  if (draftState.tokenData.data.mattress[index].images) {
                    draftState.tokenData.data.mattress[index].images.push(file.name);
                  } else {
                    draftState.tokenData.data.mattress[index].images = [file.name];
                  }
                }
                return draftState;
              });
              dispatch(setColl(tokenData));
              const update = type == 'item' ? { items: tokenData.tokenData.data.items } : { mattress: tokenData.tokenData.data.mattress }
              FirebaseApp().update(urlParams.data.URLRoomName, update);
              const body = new URLSearchParams()
              body.append('o_id', o_id)
              body.append('item_id',id.toString())
              body.append('count', '1')
              body.append('type', type);
              body.append('company_id', collection.tokenData.decode.company_id)
              body.append('company_code',collection.tokenData.decode.company_code)
              body.append('userName',collection.tokenData.decode.userName)
              body.append('sendBy',collection.tokenData.data.sendBy)
              axios.post(`https://${collection.tokenData.data.host}/apis/twilo/uploadItemImageVideoCalllog`, body,
                        {
                          headers: {
                            'content-type': 'application/x-www-form-urlencoded'
                          }
                        })
                        .catch(function (error) {
                          console.log(error);
                        });          
            
              let data = {
                order_id: o_id,
                company_id: collection.tokenData.decode.company_id,
                item_id: id.toString(),
                image_name: file.name,
                type
              }
              sendImages(collection.tokenData.data.host, data);
              setOpen(false);
            })
            .catch(err => {
              console.log('Upload 1 failed:', err);
            });
        }
      }, 'image/jpeg');
    }
  };

  return (
    <div>
      <Backdrop open={openBack} onClick={handleCloseBack}>
        <CircularProgress />
      </Backdrop>
      <Button
        id="basic-button"
        className={props.className}
        disabled={!hasVideoInputDevices || props.disabled}
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        <IconContainer>
          <BackgroundIcon />
        </IconContainer>
        {!hasVideoInputDevices ? 'No Video' : 'Add Image'}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {' '}
        {(items.length || mattress.length) && menuItems()}
      </Menu>
    </div>
  );
}
